import { render, staticRenderFns } from "./upload-psd.vue?vue&type=template&id=0450d916&scoped=true&"
import script from "./upload-psd.vue?vue&type=script&lang=js&"
export * from "./upload-psd.vue?vue&type=script&lang=js&"
import style0 from "./upload-psd.vue?vue&type=style&index=0&id=0450d916&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0450d916",
  null
  
)

export default component.exports